import { PageCalloutBanner } from './PageCalloutBanner';
import { HeroButton } from './HeroButton';
import { jsx as _jsx } from "react/jsx-runtime";
/** Renders a single full-width callout banner from a placement. */
export function PageCalloutBannerCard({
  placement
}) {
  var _ref, _calloutContent$iconU;
  const {
    calloutContent
  } = placement;
  const logoUrl = (_ref = (_calloutContent$iconU = calloutContent.iconUrl) !== null && _calloutContent$iconU !== void 0 ? _calloutContent$iconU : calloutContent.imageUrl) !== null && _ref !== void 0 ? _ref : '';
  return /*#__PURE__*/_jsx(PageCalloutBanner, {
    title: calloutContent.title,
    description: calloutContent.description,
    buttonText: calloutContent.buttonText,
    buttonUrl: calloutContent.buttonUrl,
    logoUrl: logoUrl,
    logoAlt: calloutContent.title,
    CtaButton: HeroButton
  });
}